import React from 'react';
import { useStyle } from 'react-native-style-utilities';
import { BodyText } from '@sg/garnish';

export const HomeEyebrowText = (props: HomeEyebrowTextProps) => {
  const textStyles = useStyle(
    () => ({
      color: props.fontColor,
    }),
    [props.fontColor],
  );

  return (
    <BodyText sizeMatch={['18', '24']} style={textStyles}>
      {props.text}
    </BodyText>
  );
};

type HomeEyebrowTextProps = {
  text: string;
  fontColor: string;
};
